<template>
  <div class="relative w-full">
    <take-off :show="isCurrent(1)" @leave="leave" @next="next" @skip="skip" />
    <barefoot :show="isCurrent(2)" @leave="leave" @next="next" @skip="skip" />
    <show-ankles :show="isCurrent(3)" @leave="leave" @next="next" @skip="skip" />
    <sit :show="isCurrent(4)" @leave="leave" @next="next" @skip="skip" />
  </div>
</template>

<script>
import page from '@/mixins/page';
import leave from '@/mixins/leave';

import TakeOff from '@/components/FootScan/TakeOff.vue';
import Barefoot from '@/components/FootScan/Barefoot.vue';
import ShowAnkles from '@/components/FootScan/ShowAnkles.vue';
import Sit from '@/components/FootScan/Sit.vue';

export default {
  name: 'ThingsToNote',
  mixins: [page, leave],
  components: {
    TakeOff,
    Barefoot,
    ShowAnkles,
    Sit,
  },
  mounted() {
    this.next();
  },
  data: () => ({
    currentPageNo: 0,
  }),
  methods: {
    skip() {
      this.$events.goto('FootScan/Scan');
    },
    next() {
      const newPage = this.currentPageNo + 1;
      if (!this.lastScreen) {
        this.currentPageNo = newPage;
      } else {
        this.$events.goto('FootScan/Scan');
      }
    },
    isCurrent(index) {
      return this.currentPageNo === index;
    },
  },
  computed: {
    lastScreen() {
      return this.currentPageNo >= 4;
    },
  },
};
</script>

<style scoped></style>
